<template>
  <div>
    <div class="question">
      <span>{{ index + 1 }}.</span>
      <div>{{ question.question }}</div>
    </div>
    <img
      v-if="questionImageSrc"
      :src="questionImageSrc"
      class="image"
      @click="openDialogZoomImage()"
    >
    <VDivider class="mt-2 mb-4" />

    <Modal :modal-active="dialogZoomImage" :show-buttons="false" @close="closeDialogZoomImage">
      <template #main>
        <div class="dialog-img-content">
          <img v-if="questionImageSrc" :src="questionImageSrc" class="question-image">
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import { toRefs, computed, ref } from '@vue/composition-api';
import Modal from '../Modal.vue';

export default {
  name: 'Question',
  components: {
    Modal,
  },
  props: {
    question: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
  },
  setup(props) {
    const { question } = toRefs(props);

    const dialogZoomImage = ref(false);

    const questionImageSrc = computed(() => question.value?.image?.url);

    function closeDialogZoomImage() {
      dialogZoomImage.value = false;
    }

    function openDialogZoomImage() {
      dialogZoomImage.value = true;
    }

    return {
      questionImageSrc,
      openDialogZoomImage,
      closeDialogZoomImage,
      dialogZoomImage,
    };
  },
};
</script>

<style lang="scss" scoped>
.question {
  margin-top: 32px;
  display: flex;
  color: #333333;
  font-size: 18px;
  line-height: 28px;

  span {
    margin-right: 4px;
  }
}

.image {
  max-width: 400px;
  margin: 15px 0;
  cursor: zoom-in;
  object-fit: contain;
  max-height: 400px;
  @media screen and (max-width: 599px) {
    max-width: 100%;
  }
}
.close-button {
  position: absolute;
  right: 15px;
  top: 15px;
  width: 25px;
  height: 25px;
  @media screen and (max-width: 599px) {
    top: -90px;
  }
}

.dialog-img-content {
  position: relative;
  padding: 55px;
  display: flex;
  align-items: center;
  justify-content: center;
  @media screen and (max-width: 599px) {
    padding: 0;
    height: 600px;
    display: flex;
    justify-content: center;
  }
}
.question-image {
  background-color: #fff;
  max-height: 600px;
  max-width: 100%;
  @media screen and (max-height: 800px) {
    max-height: 500px;
  }
}
</style>
